import React, { useState } from 'react'
import { Avatar, Box, Chip, CircularProgress, Divider, InputAdornment, List, ListItem, ListItemAvatar, ListItemText, TextField, Typography } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search';
import { useSelector } from 'react-redux';
import { selectWhatsappState } from '../../state/whatsapp/whatsappSelector';
import Styles from './whatsapp.module.scss'

const WhatsappSidebar = ({ selectedContact, onSelectContact }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const { userList, isUserListLoading } = useSelector(selectWhatsappState);

    const filteredContacts = userList.filter(
        (contact) => contact.phone.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const formatTime = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const now = new Date();
        const isToday = date.toDateString() === now.toDateString();
        if (isToday) {
            return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        }
        return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
    };

    const formatPhone = (phone) => {
        return phone ? phone.replace('whatsapp:', '') : '';
    };

    return (
        <Box className={Styles.sidebar}>
            <Box sx={{ p: 2 }}>
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Search contacts..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon fontSize="small" />
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>
            <Divider />
            {isUserListLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                    <CircularProgress size={28} />
                </Box>
            ) : (
                <List disablePadding>
                    {filteredContacts.map((contact) => (
                        <React.Fragment key={contact.messageSid}>
                            <ListItem
                                className={`${Styles.sidebarItem} ${selectedContact?.phone === contact.phone ? Styles.sidebarItemActive : ''}`}
                                onClick={() => onSelectContact(contact)}
                                alignItems="flex-start"
                                sx={{ px: 2, py: 1.5 }}
                            >
                                <ListItemAvatar>
                                    <Avatar sx={{ bgcolor: '#25D366', color: '#fff' }} />
                                </ListItemAvatar>
                                <ListItemText
                                    primary={
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography variant="subtitle2" noWrap>
                                                {formatPhone(contact.phone)}
                                            </Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                {formatTime(contact.messageAt)}
                                            </Typography>
                                        </Box>
                                    }
                                    secondary={
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
                                            <Typography variant="body2" color="text.secondary" noWrap sx={{ maxWidth: '70%' }}>
                                                {contact.lastMessage}
                                            </Typography>
                                            {contact.status && (
                                                <Chip
                                                    label={contact.status}
                                                    size="small"
                                                    sx={{
                                                        fontSize: 10,
                                                        height: 20,
                                                        bgcolor: contact.status === 'delivered' ? '#e8f5e9'
                                                            : contact.status === 'read' ? '#e3f2fd'
                                                            : contact.status === 'undelivered' ? '#fce4ec'
                                                            : '#f5f5f5',
                                                        color: contact.status === 'delivered' ? '#2e7d32'
                                                            : contact.status === 'read' ? '#1565c0'
                                                            : contact.status === 'undelivered' ? '#c62828'
                                                            : '#616161',
                                                    }}
                                                />
                                            )}
                                        </Box>
                                    }
                                />
                            </ListItem>
                            <Divider component="li" />
                        </React.Fragment>
                    ))}
                    {filteredContacts.length === 0 && !isUserListLoading && (
                        <Box sx={{ p: 3, textAlign: 'center' }}>
                            <Typography variant="body2" color="text.secondary">
                                No contacts found
                            </Typography>
                        </Box>
                    )}
                </List>
            )}
        </Box>
    )
}

export default WhatsappSidebar
